const initialState = {

    //ledger account details
    loadingLedgerAccountDetail: false,
    LedgerAccountDetail: {},
    LedgerAccountDetailError: '',


}

const AccountMasterReducer = (state = initialState, action) => {
    switch (action.type) {


        //ledger account details//
        case 'FIND_LEDGER_DETAIL_REQUEST':
            return {
                ...state,
                loadingLedgerAccountDetail: true,
                LedgerAccountDetail: {},
                LedgerAccountDetailError: '',
               
            };
        case 'FIND_LEDGER_DETAIL_SUCCESS':
            return {
                ...state,
                loadingLedgerAccountDetail: false,
                LedgerAccountDetail: action.payload.data,
                
            };
        case 'FIND_LEDGER_DETAIL_FAILURE':
            return {
                ...state,
                loadingLedgerAccountDetail: false,
                LedgerAccountDetailError: action.payload,
            };
        //ledger account details//

        default:
            return state;
    }
}

export default AccountMasterReducer;